import React from 'react'
import BeatLoader from 'react-spinners/BeatLoader'

import { Container } from './styles'

function Button({
  children,
  backgroundColor = 'var(--primary)',
  loading = false,
  onClick,
  color = '#fff',
  fitContent,
  margin,
  padding,
  type = 'button',
  disabled = false
}) {
  return (
    <Container
      $backgroundColor={backgroundColor}
      $loading={loading}
      $color={color}
      onClick={onClick}
      $margin={margin}
      $padding={padding}
      $fitContent={fitContent}
      type={type}
      disabled={disabled}
    >
      {loading ? <BeatLoader size={15} color={color} /> : children}
    </Container>
  )
}

export default Button
